<template>
	<div style="width:800px; height:600px;" @keyup.esc.prevent="close()">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type mgr_5">
					<select v-model="closed_yn" class="tbl_select sm_int" :disabled="operation == 'S'">
						<option v-for="tag in this.$closedTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type mgr_5">
					<select v-model="active_yn" class="tbl_select sm_int" :disabled="operation == 'S'">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type mgr_5">
					<input type="text" class="int_type sm_int" v-model="keyword" placeholder="Keyword" ref="spkeyword" autofocus autocomplete="off" @keyup.enter.prevent="search()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<div ref="ttt" class="view_inner">
			<div class="fixed-table-container" style="height:470px;" ref="div_wrapper_parent">
				<div class="table-wrapper" ref="div_wrapper">
					<table ref="item_list" id="item_list" class="list_tbl tbl_pointer">
						<thead>
							<tr>
								<th style="text-align:center;width:15%;"><div class="th-text">Code</div></th>
								<th style="text-align:center;width:10%;"><div class="th-text">WH Code</div></th>
								<th style="text-align:center;"><div class="th-text">Name</div></th>
								<th style="text-align:center;width:10%;">
									<div class="th-text ">{{ headers.class }}Group</div>
								</th>
								<th style="text-align:center;width:7%;"><div class="th-text">DeptA</div></th>
								<th style="text-align:center;width:7%;"><div class="th-text">DeptB</div></th>
								<th style="text-align:center;width:7%;"><div class="th-text">Category</div></th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="itemClass in itemClasses" v-bind:key="itemClass.code" v-bind:class="{ on: itemClass.code == selectedItemClass.code }" @click="selectRow(itemClass)" @dblclick="selectRowDoubleClick(itemClass)">
								<td ref="item">
									{{ itemClass.code }}<span v-if="itemClass.so_blocked">&nbsp;<font color="red">Blocked</font></span>
								</td>
								<td>{{ itemClass.wh_code }}</td>
								<td class="truncate">{{ itemClass.name }}</td>
								<td>{{ itemClass.class_group_code }}</td>
								<td>{{ itemClass.dept_a_code }}</td>
								<td>{{ itemClass.dept_b_code }}</td>
								<td>{{ itemClass.category_code }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- <div>
					{{ selectedUserIds }}
				</div> -->
			</div>

			<br />

			<div class="view_bottom_bt">
				<a href="javascript:;" id="save" type="button" class="gray_bt" @click="close()">Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import '@/assets/css/table_box.css';
import { apiSelectItemClassList } from '@/api/item/class.js';

export default {
	data: function() {
		return {
			closed_yn: 'N',
			active_yn: 'Y',

			itemClasses: [],
			selectedItemClass: {},

			keyword: null,
		};
	},
	computed: {
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	props: {
		initialKeyword: String,
		code_only: {
			type: Boolean,
			default: false,
		},
		// #3320: SO 품목 선택(Sales SO)에서 연 클래스 검색만 켠다. 다른 부모(Promotion,
		// ItemClassSelect, ItemClassSelectMulti, ItemPopupSample)는 기본값 false 라 무영향이다.
		soItemSelect: {
			type: Boolean,
			default: false,
		},
		close_on_select: {
			type: Boolean,
			default: true,
		},

		operation: null,
	},
	methods: {
		reset() {
			this.keyword = null;
			this.itemClasses = [];
		},
		search() {
			this.selectItemClasses();
		},
		async selectItemClasses() {
			var param = {
				keyword: this.keyword,
				paging_yn: 'N',
				active_yn: this.active_yn,
				closed_yn: this.closed_yn,
			};
			if (this.code_only) param.code_only = true;
			// #3320: 값 대입 금지. MyBatis <if test='so_item_select != null'> 은 false 에도 참이다.
			if (this.soItemSelect) param.so_item_select = true;

			// if (this.operation == 'S') param.for_sale = true;
			// else if (this.operation == 'P') param.for_purchase = true;
			const { data } = await apiSelectItemClassList(param);

			this.itemClasses = data.itemClassList;

			if (this.itemClasses.length == 1) {
				this.selectRowDoubleClick(this.itemClasses[0]);
			} else if (this.itemClasses.length > 0) {
				this.selectedItemClass = this.itemClasses[0];
				//this.$refs.ttt.focus();
				this.$refs.spkeyword.blur();
			} else {
				this.selectedItemClass = {};
				// #3320: 새 필터로 결과가 비면 무음 빈 팝업이 되므로 이 경로에서만 원인을 알린다.
				if (this.soItemSelect) this.$toast.error('No sellable item for this keyword');
				this.$refs.spkeyword.focus();
			}
		},

		selectRow(itemClass) {
			this.selectedItemClass = itemClass;
		},
		down() {
			//console.log('test');
			var vm = this;
			if (this.selectedItemClass.code) {
				var index = this.itemClasses.findIndex(function(ic) {
					return ic.code === vm.selectedItemClass.code;
				});

				//console.log(index);

				if (index < this.itemClasses.length - 1) {
					this.selectedItemClass = this.itemClasses[index + 1];

					//console.log(this.$refs['item'][index + 1].scrollHeight);
					if (this.$refs['item'][index + 1].offsetTop + 2 * this.$refs['item'][index + 1].scrollHeight > this.$refs.div_wrapper.scrollTop + this.$refs.div_wrapper_parent.scrollHeight) {
						this.$refs.div_wrapper.scrollTop += this.$refs['item'][index + 1].scrollHeight + 1;
					}
				}
			}
		},

		up() {
			//console.log('test');
			var vm = this;
			if (this.selectedItemClass.code) {
				var index = this.itemClasses.findIndex(function(ic) {
					return ic.code === vm.selectedItemClass.code;
				});

				//console.log(index);

				if (index > 0) {
					this.selectedItemClass = this.itemClasses[index - 1];

					//console.log(this.$refs['item'][index - 1].offsetTop, this.$refs['item'][index - 1].scrollHeight, this.$refs.div_wrapper.scrollTop, this.$refs.div_wrapper_parent.scrollHeight);
					// if (this.$refs['item'][index - 1].offsetTop + 2 * this.$refs['item'][index - 1].scrollHeight < this.$refs.div_wrapper.scrollTop + this.$refs.div_wrapper_parent.scrollHeight) {
					if (this.$refs['item'][index - 1].offsetTop < this.$refs.div_wrapper.scrollTop) {
						this.$refs.div_wrapper.scrollTop = this.$refs['item'][index - 1].offsetTop;
					}
				} else {
					this.selectedItemClass = {};
					this.$refs.spkeyword.focus();
				}
			}
		},

		selectRowDoubleClick(itemClass) {
			this.$emit('set-item-class', itemClass);
			this.$emit('set-item-class2', itemClass);
			//this.$emit('close', true);
			//this.$emit('close');
			if (this.close_on_select) this.close();
		},
		keyInput(ev) {
			if (ev.keyCode == 27) this.close();
			else if (ev.keyCode == 38) {
				this.up();
				ev.preventDefault();
			} else if (ev.keyCode == 40) {
				this.down();
				ev.preventDefault();
			} else if (ev.keyCode == 13) {
				if (this.selectedItemClass.code) this.selectRowDoubleClick(this.selectedItemClass);
			}
			this.$emit('cancel');
		},

		async index() {},
		close() {
			//console.log('closing');
			this.$emit('close');
		},
	},
	created() {
		this.index();
		if (this.initialKeyword) {
			this.keyword = this.initialKeyword;
			this.selectItemClasses();
		}
		//this.selectPartners();
		//this.item = _.cloneDeep(this.selectedItem);
	},
	mounted() {
		inputSelectOnClick();

		setTimeout(() => {
			this.$refs.spkeyword.focus();
		}, 10);

		var vm = this;
		window.addEventListener('keydown', function(ev) {
			vm.keyInput(ev);
			ev.stopPropagation();
		});
	},
};
</script>

<style></style>
